import React from "react";
import Box from '@mui/material/Box';
import PayloadBuilder from '../../components/PayloadBuilder/PayloadBuilder';
import { readableStepName, escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../../components/DetailItem/DetailItem';
import {StakeholdersDetails} from "../../components/StakeholdersDetails/StakeholdersDetails";

export const DataCustodyReceivedEventModel = (event) => {
    return (
    <>
      <Box
        sx={{
          width: '100%',
          border: '1px solid lightgrey',
          borderRadius: '4px',
          padding: '20px',
          marginBottom: '20px',
          display: 'block',
        }}>
        <p className='details-title'>
          <b>
            {
              readableStepName(event['@type'])
            }
          </b>
        </p>
        <DetailItem title='Title' content={escapeEmptyDetail(event.title)} />
        <DetailItem title='Description' content={escapeEmptyDetail(event.description)} />
          <StakeholdersDetails newStakeholders={event.newCustodians} oldStakeholders={event.oldCustodians} />
        <DetailItem title='Schema' content={escapeEmptyDetail(event.schema)} />
        <DetailItem title='Created at' content={event.createdAt.split('T', 1) + ' ' + event.createdAt.split('T', 2)[1].split('.', 1)+' (GMT)'} />
      </Box>
      <Box
        sx={{
          width: '100%',
          border: '1px solid lightgrey',
          borderRadius: '4px',
          padding: '20px',
          marginBottom: '20px',
          display: 'block',
        }}>
          { event.payload &&
            <PayloadBuilder payload={event.payload} />
          }
      </Box>
    </>
  );
};
